// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__k-afu","circular-rotate":"Spinner_circular-rotate__sl6E5","circle":"Spinner_circle__1gtrv","circular-dash":"Spinner_circular-dash__9y3IJ"};